import { IApplicant } from './applicant/iapplicant';
import { IAttachments } from './attachments/iattachments';
import { IDegree } from './degree/idegree';
import { IApplication } from './iapplication';
import { IQualification } from './qualifications/iqualification';
import { IQualificationBasis } from './qualifications/iqualification-basis';
import { ISubmitApplication } from './service/isubmit-application';
import { ISpecialEducation } from './special-education/ispecial-education';

export class ModelUtil {

    public static toSubmitApplication(input: IApplication): ISubmitApplication {
        const applicant: IApplicant = input.applicant;
        const degree: IDegree = input.degree;
        const specialEducation: ISpecialEducation = input.specialEducation;
        // format ssn.
        const ssn = input.applicantSsn.length > 8 ?
            ModelUtil.formatSsn(input.applicantSsn)
            : ModelUtil.formatDateOfBirth(input.applicantSsn);
        return {
            applicant: {
                applicantAddress: applicant.applicantAddress,
                applicantCity: applicant.applicantCity,
                applicantEmail: applicant.applicantEmail,
                applicantName: applicant.applicantName,
                applicantPhone: applicant.applicantPhone,
                applicantPostalCode: applicant.applicantPostalCode,
                applicantSsn: ssn,
            },
            applicationData: {
                degree,
                deliveryMethod: input.attachments ? input.attachments.deliveryMethod : null,
                otherQualification: input.otherQualification,
                payment: input.payment,
                specialEducation,
                tags: input.tags,
                vocationalQualification: input.vocationalQualification,
            },
            attachments: input.attachments ? input.attachments.attachments : null,
            dateOfArrival: input.dateOfArrival,
            skolverketCaseId: input.skolverketCaseId,
            type: input.type,
            userName: input.userName,
        };
    }

    public static clean(obj: any): void {
        for (const prop in obj) {
            if (obj[prop] === null || obj[prop] === undefined) {
                delete obj[prop];
            }
        }
    }

    public static isEmpty(obj: any): boolean {
        for (const prop in obj) {
            if (obj[prop]) {
                return false;
            }
        }
        return true;
    }

    public static getDateOfBirth(ssn: string): Date {
        const year = Number(ssn.substr(0, 4));
        const mon = Number(ssn.substr(4, 2));
        const day = Number(ssn.substr(6, 2));
        return new Date(year, mon - 1, day);
    }

    public static formatSsn(ssn: string): string {
        if (ssn) {
            ssn = ssn.replace('-', '');
            if (ssn.length === 10) {
                const currentYear = new Date().getFullYear().toString().substr(2, 2);
                const yearOfBirth = ssn.substr(0, 2);
                ssn = yearOfBirth >= currentYear ? '19' + ssn : '20' + ssn;
            }
            ssn = ssn.substr(0, 8) + '-' + ssn.substr(8, 4);
        }
        return ssn;
    }

    public static formatDateOfBirth(dateOfBirth: string): string {
        if (dateOfBirth) {
            if (dateOfBirth.length === 6) {
                const currentYear = new Date().getFullYear().toString().substr(2, 2);
                const yearOfBirth = dateOfBirth.substr(0, 2);
                dateOfBirth = yearOfBirth >= currentYear ? '19' + dateOfBirth : '20' + dateOfBirth;
            }
        }
        return dateOfBirth;
    }

    public static emptyApplication(): IApplication {
        return {
            applicant: this.emptyApplicant(),
            applicantSsn: '1212121212',
            attachments: this.emptyAttachments(),
            dateOfArrival: null,
            degree: this.emptyDegree(),
            otherQualification: { qualifications: [] },
            payment: null,
            skolverketCaseId: null,
            specialEducation: this.emptySpecialEducation(),
            tags: [],
            type: null,
            userConfirmation: null,
            userName: null,
            vocationalQualification: { qualifications: [] },
        };
    }

    public static emptyQualification(): IQualification {
        return {
            bases: [],
            languageCode: null,
            languageName: null,
            orientationCode: null,
            orientationName: null,
            studyPathCode: null,
            studyPathName: null,
            subjectCode: null,
            subjectName: null,
            typeCode: null,
            typeName: null,
            typeOfSchoolingCode: null,
            typeOfSchoolingName: null,
        };
    }

    public static emptyQualificationBasis(): IQualificationBasis {
        return {
            fromYear: null,
            toYear: null,
            typeCode: null,
            typeName: null,
            yearIntervals: null,
        };
    }

    public static emptyApplicant(): IApplicant {
        return {
            applicantAddress: null,
            applicantCity: null,
            applicantEmail: null,
            applicantName: null,
            applicantPhone: null,
            applicantPostalCode: null,
            secrecy: null,
            status: null,
        };
    }

    public static emptyAttachments(): IAttachments {
        return { attachments: [], deliveryMethod: null };
    }

    private static emptyDegree(): IDegree {
        return {
            firstExamina: {
                code: null,
                name: null,
                year: null,
            },
            secondExamina: null,
        };
    }

    private static emptySpecialEducation(): ISpecialEducation {
        return {
            specialEducationTeacher: null,
        };
    }
}
